import ApiService from './ApiService'
import createCrudService from 'utils/createCrudService'

const crud = createCrudService('company/companies')

export const { getApiData, createApiRecord, getApiRecord, updateApiRecord, updateApiStatus } = crud
export const attachImagesApi = data => ApiService.post('/company/company-images/', data)
